import { useCallback, useRef, useState } from 'react';
import type { ElementDetailAction, UpdateItemType } from '../types';

export const useUpdateItemModal = ({ onSave }: { onSave: (params: ElementDetailAction) => Promise<boolean> }) => {
  const [isOpen, setIsOpen] = useState(false);
  const updateTypeRef = useRef<ElementDetailAction['type'] | undefined>(undefined);
  const [config, setConfig] = useState<
    | {
        label: string;
        value: string;
        inputType: 'input' | 'textarea';
        placeholder: string;
        maxLength?: number;
        rows?: number;
        required?: boolean;
        handleSave: (val: string) => Promise<void>;
      }
    | undefined
  >();

  const handleSave = useCallback(
    async (val: string) => {
      const validate = await onSave({
        type: updateTypeRef.current,
        value: val,
      } as ElementDetailAction);
      if (validate) {
        setIsOpen(false);
      }
    },
    [onSave],
  );

  const openDialog = ({
    label,
    value,
    type,
    inputType,
    placeholder,
    maxLength,
    rows,
    required,
  }: {
    label: string;
    value: string;
    type: UpdateItemType;
    inputType?: 'input' | 'textarea';
    placeholder?: string;
    maxLength?: number;
    rows?: number;
    required?: boolean;
  }) => {
    updateTypeRef.current = type;
    setIsOpen(true);

    setConfig({
      label,
      value,
      inputType: inputType || 'input',
      placeholder: placeholder || '',
      maxLength: maxLength,
      rows,
      required,
      handleSave,
    });
  };

  return {
    openDialog,
    isOpen,
    setIsOpen,
    config,
  };
};
